import { Button, Pagination, Table, TableBody, TableCell, TableHead, TableRow, Typography, useMediaQuery } from "@mui/material";
import { theme } from "../../utils/theme";
import { PaginationStyle, dispatchCellStyle, employeeNameCellStyle, tableHeadCellStyle, tableRowCellStyle } from "./styled";

interface IDetailsTableProps {
  isCasual: boolean,
  data: {
    auditStatus: string,
    unavailableReason: string,
    backgroundColor: string,
    backgroundImage: string,
    employeeFullName: string,
    regId: number,
    homePortCode: string,
    boardCode: string,
    plateNumber: number,
    borderStyle: string,
    dispatchDescription: string,
    isReplacement: boolean,
    pluginDatetimeStr: string,
    declaredDatetimeStr: string,
    declaredBy: string
  }[],
  page: number,
  pageSize: number,
  onOpenClosePlateModal: (regId: number, board: string) => void,
  onPageChange: (page: number) => void
}

export const DetailsTable: React.FC<IDetailsTableProps> = ({
  isCasual, data, page, pageSize, onOpenClosePlateModal, onPageChange
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const startIndex = pageSize * (page - 1);
  const endIndex = startIndex + pageSize;
  let cols = [
    <TableCell sx={tableHeadCellStyle} key='employee' data-automation="employee-col"><Typography>Employee</Typography></TableCell>,
    <TableCell sx={tableHeadCellStyle} key='plate' data-automation="plate-col"><Typography>Plate</Typography></TableCell>,
    <TableCell sx={tableHeadCellStyle} key='dispatched' data-automation="disp-col"><Typography>Dispatched</Typography></TableCell>,
    <TableCell sx={tableHeadCellStyle} key='available' data-automation="decl-avail-col"><Typography>Declared Available</Typography></TableCell>,
    <TableCell sx={tableHeadCellStyle} key='by' data-automation="decl-by-col"><Typography>Declared By</Typography></TableCell>
  ];
  if (isCasual) {
    const pluginDateCol = <TableCell sx={tableHeadCellStyle} key='plugin' data-automation="plugin-date-col"><Typography>Plugin Date</Typography></TableCell>
    cols = [...cols.slice(0, 3), pluginDateCol, ...cols.slice(3)];
  }

  const rows = data.slice(startIndex, endIndex).map((row, i) => {
    return (
      <TableRow key={i} sx={{
        backgroundColor: row.backgroundColor
      }}>
        <TableCell sx={(theme) => employeeNameCellStyle(theme)(row.backgroundImage)}>
          <Typography>{row.employeeFullName}</Typography>
          <Typography>{row.regId} {row.homePortCode}</Typography>
        </TableCell>
        <TableCell sx={tableRowCellStyle}>
          <Button
            variant="outlined"
            onClick={() => onOpenClosePlateModal(row.regId, row.boardCode)}
          >
            {row.boardCode}{row.plateNumber}
          </Button>
        </TableCell>
        <TableCell sx={(theme) => dispatchCellStyle(theme)(row.borderStyle)}>
          <Typography>{row.dispatchDescription}</Typography>
          <Typography>{row.isReplacement && '(Called Replacement)'}</Typography>
        </TableCell>
        {isCasual && <TableCell sx={tableRowCellStyle}>{row.pluginDatetimeStr}</TableCell>}
        <TableCell sx={tableRowCellStyle}>{row.declaredDatetimeStr}</TableCell>
        <TableCell>{row.declaredBy}</TableCell>
      </TableRow>
    )
  })

  return (
    <>
      <Table className="one-level">
        <TableHead data-automation="details-cols">
          {cols.map(c => c)}
        </TableHead>
        <TableBody>
          {data.length ? rows.map(r => r) : (
            <TableRow>
              <TableCell sx={{ ...tableRowCellStyle, textAlign: 'center' }} colSpan={isCasual ? 6 : 5}>
                No Matching Records Found
              </TableCell>
            </TableRow>)}
        </TableBody>
      </Table>
      <Pagination
        count={Math.ceil(data.length / pageSize)}
        page={page}
        onChange={(_event, page) => onPageChange(page)}
        variant="outlined"
        shape="rounded"
        size={isMobile ? 'small' : 'medium'}
        sx={PaginationStyle}
        data-automation="pagination"
      />
    </>
  )
}